import { useMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { ValueTopicConfig } from 'widgets/myPortfolioCapsules/topics/value/valueTopicConfig';
import { QuantitiesOptions } from 'utils/components/QuantitiesOptions/QuanitiesOptions';
import { MyPortfolioCapsulesWidgetConfigState } from 'widgets/myPortfolioCapsules/store/config/MyPortfolioCapsulesWidgetConfigState';
import QuantitiesOptionsLinks from 'utils/components/QuantitiesOptions/QuantitiesOptionsLinks';
import React from 'react';

export function ValueTopicToolbar() {
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsulesConfigSlice();

    const { quantities } = config as unknown as ValueTopicConfig;
    const onQuantitiesChange = (nextQuantities: QuantitiesOptions) => {
        const delta: Partial<
            MyPortfolioCapsulesWidgetConfigState & ValueTopicConfig
        > = { quantities: nextQuantities };
        dispatchConfigChanged(delta);
    };

    return (
        <div className="ValueTopicToolbar">
            <QuantitiesOptionsLinks
                value={quantities}
                onChange={onQuantitiesChange}
            />
        </div>
    );
}
